import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
type Cols = 3 | 4;
const gridCols: Record<Cols, string> = {
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4'
};

/**
 * Below lg, shows one card at a time with simple previous / next arrows
 * underneath, so long card sections do not become an endless mobile
 * scroll. At lg and above it renders the ordinary grid, unchanged.
 */
export function CardCarousel({
  children,
  cols = 4,
  tone = 'light',
  className = ''
}: {
  children: React.ReactNode;
  cols?: Cols;
  /** Use "dark" on Black Coffee or Purple Pennant sections. */
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const items = React.Children.toArray(children);
  const [index, setIndex] = useState(0);
  const count = items.length;
  const go = (next: number) => setIndex(Math.min(Math.max(next, 0), count - 1));
  const counterTone = tone === 'dark' ? 'text-paper/55' : 'text-coffee/45';
  const buttonTone = tone === 'dark' ? 'border-paper/30 text-paper hover:border-paper' : 'border-oat text-coffee hover:border-coffee';
  return <div className={className} data-id="element-53" data-mp="333l54occpwuj">
      {/* Mobile & tablet — one card, arrows below */}
      <div className="lg:hidden" data-id="element-54" data-mp="2p3k51b3wutg4">
        <div data-id="element-55" data-mp="2p28tuq84yjez">{items[index]}</div>

        {count > 1 && <div className="mt-8 flex items-center justify-between gap-6" data-id="element-56" data-mp="2u24v4hpg7wqu">
            <p className={`type-eyebrow text-[9px] ${counterTone}`} data-id="element-57" data-mp="2u4hkvh1g7beg">
              {index + 1} / {count}
            </p>
            <div className="flex items-center gap-3" data-id="element-58" data-mp="2k478fyn8m80c">
              <button type="button" onClick={() => go(index - 1)} disabled={index === 0} aria-label="Previous" className={`flex h-12 w-12 items-center justify-center rounded-full border transition-colors duration-150 disabled:opacity-30 ${buttonTone}`} data-id="element-59" data-mp="2k5s3dpdgrsyq">
                <ArrowLeftIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-60" data-mp="21dg1f3qq2tp4" />
              </button>
              <button type="button" onClick={() => go(index + 1)} disabled={index === count - 1} aria-label="Next" className={`flex h-12 w-12 items-center justify-center rounded-full border transition-colors duration-150 disabled:opacity-30 ${buttonTone}`} data-id="element-61" data-mp="1i94as6nlnjlt">
                <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-62" data-mp="13lrj00778hmz" />
              </button>
            </div>
          </div>}
      </div>

      {/* Desktop — the original grid */}
      <div className={`hidden gap-6 lg:grid ${gridCols[cols]}`} data-id="element-63" data-mp="1wa6wujelgtwq">{items}</div>
    </div>;
}